import { render } from "./collegeList.vue?vue&type=template&id=0d168868&scoped=true"
import script from "./collegeList.vue?vue&type=script&lang=js"
export * from "./collegeList.vue?vue&type=script&lang=js"

import "./collegeList.vue?vue&type=style&index=0&id=0d168868&lang=scss&scoped=true"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d168868"]])

export default __exports__